import React, { memo } from 'react';
import { BookOpenIcon, PencilIcon, EyeIcon, HeartIcon, CalendarIcon, SparklesIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function WhatsIncluded() {
  const items = [{
    icon: SparklesIcon,
    label: 'Lenguaje',
    desc: 'Estimulación oral y vocabulario'
  }, {
    icon: PencilIcon,
    label: 'Motricidad',
    desc: 'Trazos, recortes y coordinación'
  }, {
    icon: EyeIcon,
    label: 'Atención',
    desc: 'Observación y memoria visual'
  }, {
    icon: HeartIcon,
    label: 'Emociones',
    desc: 'Reconocimiento y autorregulación'
  }, {
    icon: BookOpenIcon,
    label: 'Creatividad',
    desc: 'Arte, color y expresión libre'
  }, {
    icon: CalendarIcon,
    label: 'Rutinas',
    desc: 'Hábitos diarios divertidos'
  }];
  const previewImages = ['https://cdn.magicpatterns.com/uploads/3K2TfRQVDFNBF9RzEQ2Xn2/ChatGPT_Image_21_may_2026,_23_56_52.png', 'https://cdn.magicpatterns.com/uploads/uCVyqwARyspzeGqRzuySA7/ChatGPT_Image_21_may_2026,_23_58_16.png', 'https://cdn.magicpatterns.com/uploads/aDcfg38Fj8bBiVpro1FmJp/ChatGPT_Image_21_may_2026,_23_59_35.png'];
  return <section className="bg-brand-green-50/40 px-5 py-10 sm:py-12" data-id="element-183">
      <div className="max-w-3xl mx-auto" data-id="element-184">
        <div className="text-center mb-8" data-id="element-185">
          <p className="text-xs uppercase tracking-wider text-brand-green-600 font-bold mb-3" data-id="element-186">
            Qué incluye
          </p>
          <h2 className="font-extrabold text-3xl sm:text-4xl text-brand-ink leading-tight tracking-tight" data-id="element-187">
            Todo listo para imprimir y jugar
          </h2>
          <p className="mt-3 text-slate-600 max-w-md mx-auto" data-id="element-188">
            Más de 100 páginas pensadas para estimular el desarrollo de tu hijo
            en cada etapa.
          </p>
        </div>

        {/* Preview gallery */}
        <a href="https://impulsodigital.vip/cart/44763616936022:1" className="grid grid-cols-3 gap-3 sm:gap-4 mb-8" data-id="element-189">
          {previewImages.map((img, idx) => <div key={idx} className={`rounded-2xl overflow-hidden shadow-soft bg-white border border-slate-100 hover:shadow-soft-lg transition-shadow ${idx === 1 ? 'translate-y-3' : ''}`} data-id="element-190">
              <img src={img} alt={`Vista previa ${idx + 1}`} className="w-full aspect-[3/4] object-cover" data-id="element-191" />
            </div>)}
        </a>

        {/* Category grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3" data-id="element-192">
          {items.map(({
          icon: Icon,
          label,
          desc
        }) => <div key={label} className="bg-white rounded-2xl p-4 border border-slate-100 shadow-soft" data-id="element-193">
              <div className="w-9 h-9 rounded-xl bg-brand-green-50 flex items-center justify-center mb-3" data-id="element-194">
                <Icon className="w-5 h-5 text-brand-green-600" data-id="element-195" />
              </div>
              <h3 className="font-bold text-sm text-brand-ink" data-id="element-196">{label}</h3>
              <p className="text-xs text-slate-500 mt-0.5 leading-snug" data-id="element-197">
                {desc}
              </p>
            </div>)}
        </div>

        <div className="mt-10" data-id="element-198">
          <CTAButton text="Quiero acceder al kit" data-id="element-199" />
          <p className="text-center text-xs text-slate-500 mt-3" data-id="element-200">
            Descarga inmediata · $19.990 ARS
          </p>
        </div>
      </div>
    </section>;
}